import { ConceptGroupConceptsPanel } from '@verantos-dev/feature-concept-group-detail';

import { usePreviewConceptsTable } from '../../../hooks/usePreviewConceptsTable';

// --- Concepts tab — the SHARED concepts panel (identical to the Ready detail
// view) over the preview concepts hook. --------------------------------------

export const DraftConceptsTab = ({
  previewId,
  groupName,
  invalidValues,
  conceptCount,
}: {
  previewId: string | null;
  groupName: string;
  invalidValues: string[];
  conceptCount: number | null;
}) => {
  const model = usePreviewConceptsTable({ previewId, groupName });
  return (
    <ConceptGroupConceptsPanel
      model={model}
      testIdPrefix="cg-preview"
      conceptCount={conceptCount}
      invalidValues={invalidValues}
      canDownload={Boolean(previewId)}
    />
  );
};
